import { ICreateHOPlan } from 'interfaces/HOPlan/HOPlan';
import * as HOPlanQuery from './GraphQL/Queries/hoPlantQuery';
import {
  HOPLAN_VARIABLE,
  ICalculateRevenueHoTeamsale,
  IGetTrackRevenueHo,
  IGetTrackRevenueHoDetail,
  IParams,
} from './GraphQL/Variables/hoPlan';
import axiosGraphQL from './GraphQL/axiosGraphQL';

interface IProgressBaseParams {
  year: string;
  teamId?: string;
  isCN?: boolean;
  plant?: string;
  isSale?: boolean;
  isAdmin?: boolean;
}

interface IProgressCNParams extends IProgressBaseParams {
  isCN: true;
  plant: string;
}

interface IProgressSaleParams extends IProgressBaseParams {
  isSale: true;
  plant: string;
  teamId: string;
}

interface IProgressOtherParams extends IProgressBaseParams {
  isAdmin: true;
}

export type IProgressParams =
  | IProgressCNParams
  | IProgressOtherParams
  | IProgressSaleParams;

const HOPlanApi = {
  getRevenueHOPlanList: async (params: IParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: HOPlanQuery.GET_REVENUE_PLAN_HO,
      variables: HOPLAN_VARIABLE.getListHOPlan(params),
    });
  },
  getRevenueHOPlanById: async (revenuePlanHOId: string) => {
    return await axiosGraphQL.post('graphql', {
      query: HOPlanQuery.GET_REVENUE_PLAN_HO_DETAIL,
      variables: HOPLAN_VARIABLE.detail(revenuePlanHOId),
    });
  },
  getRevenuePlanHOYearByPlantId: async (params: {
    year: string;
    plantId: string;
  }) => {
    return await axiosGraphQL.post('graphql', {
      query: HOPlanQuery.GET_REVENUE_PLAN_HO_YEAR_BY_PLANTID,
      variables: HOPLAN_VARIABLE.getRevenueHOYearByPlant(params),
    });
  },
  updateRevenueHOPlan: async (data: ICreateHOPlan[]) => {
    return await axiosGraphQL.post('graphql', {
      query: HOPlanQuery.UPDATE_REVENUE_PLAN_HO,
      variables: HOPLAN_VARIABLE.updateHOPlan(data),
    });
  },
  createRevenueHOPlan: async (data: ICreateHOPlan[]) => {
    return await axiosGraphQL.post('graphql', {
      query: HOPlanQuery.CREATE_REVENUE_PLAN_HO,
      variables: HOPLAN_VARIABLE.createHOPlan(data),
    });
  },
  deleteRevenueHOPlan: async (id: any) => {
    return await axiosGraphQL.post('graphql', {
      query: HOPlanQuery.DELETE_REVENUE_PLAN_HO,
      variables: HOPLAN_VARIABLE.deleteHOPlan(id),
    });
  },
  checkExisted: async (params: Pick<IParams, 'year' | 'plantId'>) => {
    return await axiosGraphQL.post('graphql', {
      query: HOPlanQuery.CHECK_EXISTED,
      variables: HOPLAN_VARIABLE.checkExisted(params),
    });
  },
  getRevenueHOPlanByYear: async (year: string) => {
    return await axiosGraphQL.post('graphql', {
      query: HOPlanQuery.GET_REVENUE_PLAN_HO_YEAR_BY_PLANTID,
      variables: HOPLAN_VARIABLE.getRevenueHOPlanByYear(year),
    });
  },
  getProgressRevenuePlant: async ({
    year,
    plant,
    teamId,
    isAdmin,
    isCN,
    isSale,
  }: IProgressParams) => {
    if (isAdmin)
      return await axiosGraphQL.post('graphql', {
        query: HOPlanQuery.GET_PROGRESS_REVENUE_PLAN_HO,
        variables: HOPLAN_VARIABLE.getProgressRevenuePlant({ year }),
      });

    if (isCN)
      return await axiosGraphQL.post('graphql', {
        query: HOPlanQuery.GET_PROGRESS_REVENUE_PLAN_BRANCH,
        variables: HOPLAN_VARIABLE.getProgressRevenuePlantBranch({
          year,
          plant: plant,
        }),
      });

    if (isSale)
      return await axiosGraphQL.post('graphql', {
        query: HOPlanQuery.GET_PROGRESS_REVENUE_PLAN_BRANCH,
        variables: HOPLAN_VARIABLE.getProgressRevenuePlantTeamSale({
          year,
          plant: plant,
          teamId: teamId,
        }),
      });

    throw new Error('Invalid role');
  },
  getTrackRevenueHo: async (params: IGetTrackRevenueHo) => {
    return await axiosGraphQL.post('graphql', {
      query: HOPlanQuery.GET_TRACK_REVENUE_HO,
      variables: HOPLAN_VARIABLE.getTrackRevenueHo(params),
    });
  },
  calculateRevenueHoTeamsale: async (params: ICalculateRevenueHoTeamsale) => {
    return await axiosGraphQL.post('graphql', {
      query: HOPlanQuery.CALCULATE_REVENUE_HO_TEAM_SALE,
      variables: HOPLAN_VARIABLE.calculateRevenueHoTeamsale(params),
    });
  },
  getTrackRevenueHoDetail: async (params: IGetTrackRevenueHoDetail) => {
    return await axiosGraphQL.post('graphql', {
      query: HOPlanQuery.GET_TRACK_REVENUE_HO_DETAIL,
      variables: HOPLAN_VARIABLE.getTrackRevenueHoDetail(params),
    });
  },
};

export default HOPlanApi;
